__webpack_require__.p = "https://www.vietnamworks.com/job-search/_next/";